import { LabelProps, Label } from './Label';
import classNames from 'classnames';
export function CursiveBlueLabel(props: LabelProps) {
    return (
        <Label
            {...props}
            variant="text-blue-cursive"
            className={classNames(
                'uppercase italic tracking-wide text-dark-blue',
                props.className,
            )}
        />
    );
}
